import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalCard } from './layout/ModalCard.js';
import { ModalCloseIcon } from './layout/ModalCloseIcon.js';
import { ModalContent } from './layout/ModalContent.js';
import { ModalFooter } from './layout/ModalFooter.js';
import { ModalHeader, ModalTitle } from './layout/ModalHeader.js';
/** Simplified Modal layout for everyday use */
export const ModalLayout = ({ children, accent, header, footer, closeIcon, ...rest }) => (_jsxs(ModalCard, { ...rest, children: [_jsxs(ModalHeader, { accent: accent, children: [_jsx(ModalTitle, { children: header }), " ", closeIcon && _jsx(ModalCloseIcon, {})] }), _jsx(ModalContent, { accent: accent, children: children }), _jsx(ModalFooter, { accent: accent, children: footer })] }));
